// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"ScreenReaderText-module--srOnly--3kOC5"};